/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StartChargeTask
 */
export interface StartChargeTask {
    /**
     *
     * @type {number}
     * @memberof StartChargeTask
     */
    connectorIndex?: number;
    /**
     *
     * @type {string}
     * @memberof StartChargeTask
     */
    idTag?: string;
}

/**
 * Check if a given object implements the StartChargeTask interface.
 */
export function instanceOfStartChargeTask(
    value: object,
): value is StartChargeTask {
    return true;
}

export function StartChargeTaskFromJSON(json: any): StartChargeTask {
    return StartChargeTaskFromJSONTyped(json, false);
}

export function StartChargeTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): StartChargeTask {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        idTag: json["idTag"] == null ? undefined : json["idTag"],
    };
}

export function StartChargeTaskToJSON(value?: StartChargeTask | null): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        idTag: value["idTag"],
    };
}
